import React, { Component } from 'react';
import { Trans } from 'react-i18next';
//import i18n from '../resources/i18n';
import LayoutSC from '../components/LayoutSC.jsx';
import LocalStorage from '../service/LocalStorage';
import { simpleGetRequest } from '../service/ApiService';
import {properties} from '../resources/properties.js';
import CircularProgress from '@material-ui/core/CircularProgress';

let API_URL = properties.apiURLApiService;
if (window.location.protocol === 'https:' && API_URL.includes('http://'))
  API_URL = API_URL.replace('http://', 'https://');
else if (window.location.protocol === 'http:' && API_URL.includes('https://'))
  API_URL = API_URL.replace('https://', 'http://');

class IdPDFReuse extends Component {

  constructor(props) {
    super(props);
    this.showCarrito = false;
    this.memorizedPrice = {};
    this.renderedItems = [];
    let tmpID;
    if(window.location.href.indexOf("?ID=")>0){
      tmpID = window.location.href.split("?ID=")[1];
    }

    if(this.checkDateRange(tmpID.substring(0,6))){
      const reloadedPage = LocalStorage.get('idPDFReuseReload');//LocalStorage.put('idPDFReuseReload', {presentacion: this.presentacion, producto:this.producto, item:this.item});
      if(reloadedPage !== undefined && tmpID === reloadedPage.item.id){//use reloadedPage
        this.presentacion = reloadedPage.presentacion;
        this.producto = reloadedPage.producto;
        this.item = reloadedPage.item;
      } else {
        LocalStorage.delete('idPDFReuseReload');
        this.presentacion = "sinplegar";
        this.producto = 'RapidoElaborado';
        this.item={
          id: undefined,
          title: undefined,
          subtitle: "MapaNormalSinPlegar",
          type: "Normalsinplegar",
          quantity: 1,
          url: undefined,
          price: 5.37
        };
        if(tmpID){
          this.item.id = tmpID;
          this.item.title = tmpID;
          this.item.url = API_URL + '/conectorMAC/getPDFByID?printID=' + tmpID;
          let auxYear = new Date().getFullYear().toString();
          if(auxYear.substring(auxYear.length-2) === tmpID.substring(0,2)){
            this.item.savedAt = new Date(auxYear,Number.parseInt(tmpID.substring(2,4))-1,tmpID.substring(4,6)).getTime();
          } else {
            this.item.savedAt = new Date(Number.parseInt(auxYear)-1,Number.parseInt(tmpID.substring(2,4))-1,tmpID.substring(4,6)).getTime();
          }
          this.configureProducto(tmpID);
        }
      }
      this.doPriceRequest(this.item.type, this.item.quantity);
      this.generalLoader = document.querySelectorAll('.OldPDFBlock.MuiBackdrop-root')[0];
      this.errorMessage = document.querySelectorAll('.errorRed.duplicateerror')[0];
    }
  }

  checkDateRange(stringDate){
    let auxDate = new Date();
    auxDate.setHours(0,0,0,0);
    let auxYear = auxDate.getFullYear().toString();
    if(auxYear.substring(auxYear.length-2) === stringDate.substring(0,2) || (auxYear = (Number.parseInt(auxYear)-1).toString(),auxYear.substring(auxYear.length-2) === stringDate.substring(0,2))){
      let auxDif = (auxDate.getTime() - (new Date(auxYear,Number.parseInt(stringDate.substring(2,4))-1,stringDate.substring(4,6)).getTime()));
      if(auxDif>=0 && auxDif<=604800000){// 7 días
        return true;
      }
    }
    return false;
  }

  configureProducto(id){
    if(id.endsWith("-M")){
      this.producto = 'RapidoElaborado';
      this.item.type = 'Normalsinplegar';
      this.item.subtitle = 'MapaNormalSinPlegar';
    } else if(id.endsWith("-P")){
      this.producto = 'Poster';
      this.item.type = 'PosterNormalsinplegar';
      this.item.subtitle = 'PosterNormalSinPlegar';
    } else if(id.endsWith("-F")){
      this.producto = 'Foto';
      this.item.type = 'FotoNormalsinplegar';
      this.item.subtitle = 'FotoNormalSinPlegar';
    } else {
      this.producto = 'RapidoElaborado';
      this.item.type = 'Normalsinplegar';
      this.item.subtitle = 'MapaNormalSinPlegar';
    }
  }

  goMain = () => {
    window.location.href = '/mapaalacarta';
  }

  pasteFix = (pst) => {
    if (/^\d*[1-9]\d*$/.test((pst.clipboardData || window.clipboardData).getData('text'))) {
      return false;
    }
    pst.preventDefault();
    return true;
  }

  keydownFix = (kdwn) => {
    if (kdwn.key.length === 1 && !(/[0-9]/.test(kdwn.key) || kdwn.altKey || kdwn.ctrlKey || kdwn.metaKey || kdwn.shiftKey)) kdwn.preventDefault();
  }

  updateQuantity = (e) => {
    this.showCarrito = false;
    if(e.target.value<1){
      e.target.value = 1;
      if(this.item.quantity !== 1){
        this.item.quantity = 1;
        this.updateTable();
        this.setState({});
      }else{
        this.showCarrito = true;
      }
    }else{
      this.item.quantity = e.target.value;
      this.updateTable();
      this.setState({});
    }
  }

  functionUpdatePrice = (event) => {
    if(!this.generalLoader){
      this.generalLoader = document.querySelectorAll('.OldPDFBlock.MuiBackdrop-root')[0];
    }
    if(this.errorMessage){
      this.errorMessage.parentElement.children[1].style.display = "";
      this.errorMessage.style.display = "";
    }
    this.showCarrito = false;
    const tempName = event.target.name?event.target.name:event.target.parentElement.name;
    switch (tempName) {
      case "Plegado":
        this.presentacion="plegar";
        if (this.item.type.includes('Aventura')) {
          this.item.type = 'Aventuraplegado';
          this.item.subtitle = 'MapaResistentePlegado';
        } else {
          this.item.type = 'Normalplegado';
          this.item.subtitle = 'MapaNormalPlegado';
        }
        break;
      case "Enrollado":
        this.presentacion="sinplegar";
        if (this.item.type.includes('Aventura')) {
          this.item.type = 'Aventurasinplegar';
          this.item.subtitle = 'MapaResistenteSinPlegar';
        } else {
          if (this.producto === 'Poster'){
            this.item.type = 'PosterNormalsinplegar';
            this.item.subtitle = 'PosterNormalSinPlegar';
          }else{
            if(this.producto === 'Foto'){
              this.item.type = 'FotoNormalsinplegar';
              this.item.subtitle = 'FotoNormalSinPlegar';
            }else{
              this.item.type = 'Normalsinplegar';
              this.item.subtitle = 'MapaNormalSinPlegar';
            }
          }
        }
        break
      case "Normal":
        if(this.producto === 'RapidoElaborado'){
          if(this.presentacion==="sinplegar"){
            this.item.type = 'Normalsinplegar';
            this.item.subtitle = 'MapaNormalSinPlegar';
          }else{
            this.item.type = 'Normalplegado';
            this.item.subtitle = 'MapaNormalPlegado';
          }
        }else if (this.producto === 'Poster'){
          this.item.type = 'PosterNormalsinplegar';
          this.item.subtitle = 'PosterNormalSinPlegar';
          this.presentacion = "sinplegar";
        }else{
          this.item.type = 'FotoNormalsinplegar';
          this.item.subtitle = 'FotoNormalSinPlegar';
          this.presentacion = "sinplegar";
        }
        break;
      case "Aventura":
        if(this.producto === 'RapidoElaborado'){
          if(this.presentacion==="sinplegar"){
            this.item.type = 'Aventurasinplegar';
            this.item.subtitle = 'MapaResistenteSinPlegar';
          }else{
            this.item.type = 'Aventuraplegado';
            this.item.subtitle = 'MapaResistentePlegado';
          }
        }else if (this.producto === 'Poster'){
          this.item.type = 'PosterAventurasinplegar';
          this.item.subtitle = 'PosterResistenteSinplegar';
          this.presentacion = "sinplegar";
        }else{
          this.item.type = 'FotoAventurasinplegar';
          this.item.subtitle = 'FotoResistenteSinplegar';
          this.presentacion = "sinplegar";
        }
        break
      case "Satinado":
        this.item.type = 'Satinadosinplegar';
        this.item.subtitle = 'PosterSatinadoSinPlegar';
        this.presentacion="sinplegar";
        break;
      case "Rigido":
        if(this.producto === 'Poster'){
          this.item.type = 'Rigidosinplegar';
          this.item.subtitle = 'PosterRigidoSinPlegar';
        }
        if(this.producto === 'Foto'){
          this.item.type = 'FotoRigidosinplegar';
          this.item.subtitle = 'FotoRigidoSinPlegar';
        }
        this.presentacion = "sinplegar";
        break;
      case "Fotografico":
        this.item.type = 'Fotograficosinplegar';
        this.item.subtitle = 'FotograficoSinPlegar';
        this.presentacion = "sinplegar";
        break
      default:
        if(this.producto === 'Poster'){
          this.item.type = 'PosterNormalsinplegar';
          this.item.subtitle = 'PosterNormalSinPlegar';
        } else if(this.producto === 'Foto'){
          this.item.type = 'FotoNormalsinplegar';
          this.item.subtitle = 'FotoNormalSinPlegar';
        } else {
          this.item.type = 'Normalsinplegar';
          this.item.subtitle = 'MapaNormalSinPlegar';
        }
        this.presentacion = "sinplegar";
        break;
    }
    this.generalLoader && (this.generalLoader.className = "OldPDFBlock MuiBackdrop-root activeLoader");
    if(this.memorizedPrice[this.item.type]){
      this.item.price = this.memorizedPrice[this.item.type];
      this.updateTable();
      this.generalLoader && (this.generalLoader.className = "OldPDFBlock MuiBackdrop-root");
      this.setState({});
    }else{
      this.doPriceRequest(this.item.type, this.item.quantity);
    }
    //console.log("Prod:"+this.producto+" Pres:"+this.presentacion+ " Tipo:"+this.item.type)
  }

  doPriceRequest(tipoDePapel, cantidad) {
    if(cantidad>0){
      const allTypes = properties.TIPOS_DE_PAPEL_COMPRA;
      let url = '/conectorMAC/getPrices?';
      url += tipoDePapel + '=' + cantidad;
      allTypes.filter((x) => x !== tipoDePapel).forEach((tipo) => {
        url += '&' + tipo + '=0';
      });

      simpleGetRequest(url).then(response => {
        let responseData = JSON.parse(JSON.stringify(response.data));
        this.item.price = (responseData.totalsiniva/cantidad).toFixed(2);
        this.memorizedPrice[tipoDePapel] = this.item.price;
        this.updateTable();
        this.generalLoader && (this.generalLoader.className = "OldPDFBlock MuiBackdrop-root");
        this.setState({});
        if(!this.errorMessage){
          this.errorMessage = document.querySelectorAll('.errorRed.duplicateerror')[0];
        }
      }).catch(() => console.warn('ERROR price request'));
    } else {
      this.updateTable();
      this.generalLoader && (this.generalLoader.className = "OldPDFBlock MuiBackdrop-root");
      this.setState({});
      if(!this.errorMessage){
        this.errorMessage = document.querySelectorAll('.errorRed.duplicateerror')[0];
      }
    }
  }

  addToShoppingCart() {
    if (this.item.url !== undefined && this.showCarrito) {
      const items = LocalStorage.get('mac-items') !== undefined ? LocalStorage.get('mac-items') : [];
      if(items.length && items.find(it => it.id === this.item.id && it.subtitle === this.item.subtitle && it.type === this.item.type)){
        this.showCarrito = false;
        this.errorMessage.style.display = "block";
        this.errorMessage.parentElement.children[1].style.display="none";
      }else{
        items.push(this.item);
        LocalStorage.put('mac-items', items);
        window.location.href = '/mapaalacarta/ShoppingCart';
      }
    }
  }

  updateTable(){
    if(this.item.id){
      LocalStorage.put('idPDFReuseReload', {presentacion: this.presentacion, producto:this.producto, item:this.item});
      this.renderedItems = [];
      this.renderedItems.push(
        <tr key={this.item.id}>
          <td style={{ width: '175px' }}>{this.item.id}</td>
          <td style={{ textAlign: 'right', width: '175px' }}>
            <a href={this.item.url} target='_blank' rel='noopener noreferrer'>
              <Trans i18nKey="shoppingCart.downloadMap">Descargar mapa</Trans>
            </a>
          </td>
          <td style={{ textAlign: 'center', width: '125px', maxWidth: '125px'}}>
            <input type="number" defaultValue={this.item.quantity} min="1" max="999" onChange={this.updateQuantity.bind(null)} onPaste={this.pasteFix} onKeyDown={this.keydownFix} style={{ maxWidth: '125px'}}/>
          </td>
          <td style={{ textAlign: 'right', width: '210px' }}>
            <span>{(this.item.price * this.item.quantity).toFixed(2)}€</span>
            <br/>
            <span>{this.item.price}€/<Trans i18nKey="shoppingCart.unity">Unidad</Trans></span>
          </td>
        </tr>
      );
      this.showCarrito = true;
    }
  }

  render() {
    return (
      <LayoutSC>
        <div className="OldPDFBlock MuiBackdrop-root">
          <CircularProgress color={"inherit"} size={"7vh"} className='OldPDFProgress'/>
          </div>
        <div className='shopping-cart-layout idpdfreuse-layout'>
          <div style={{overflow:'scroll'}}>
            {this.item &&(<p className='shopping-cart-title'><Trans i18nKey="dialog.oldpdf">Comprar mapa</Trans></p>)}
            {!this.item &&(<p className='shopping-cart-title'><Trans i18nKey="dialog.expiredpdf">El ID indicado ya se ha expirado</Trans></p>)}
            {this.item &&(
            <div className="pdfAllTypes" style={{display:this.producto === 'RapidoElaborado' && this.item.id?'flex':'none', height: '100px'}}>
              <div className="button-check">
                <button name="Enrollado" onClick={this.functionUpdatePrice}>
                  <i style={{
                      pointerEvents: "none"
                    }} className={this.item.type.includes("plegar")
                      ? "mc-diploma active fa-2x"
                      : "mc-diploma fa-2x"}></i>
                </button>
                <label><Trans i18nKey="step3.paper.liso">Liso</Trans></label>
                <i className={this.item.type.includes("plegar")
                    ? "checked mc-check"
                    : "checked"}></i>
              </div>
              <div className="button-check">
                <button name="Plegado" onClick={this.functionUpdatePrice}>
                  <i style={{
                      pointerEvents: "none"
                    }} className={this.item.type.includes("plegado")
                      ? "mc-map active fa-2x"
                      : "mc-map fa-2x"}></i>
                </button>
                <label><Trans i18nKey="step3.paper.plegado">Plegado</Trans></label>
                <i className={this.item.type.includes("plegado")
                    ? "checked mc-check"
                    : "checked"}></i>
              </div>
            </div>
            )}
            {this.item &&(
            <div className="pdfAllTypes" style={{display:this.item && this.item.id?'flex':'none', height: '100px'}}>
              <div className="button-check">
                <button name="Normal" onClick={this.functionUpdatePrice}>
                  <i style={{
                      pointerEvents: "none"
                    }} className={this.item.type.includes("Normal")
                      ? "mc-normal active fa-2x"
                      : "mc-normal fa-2x"}></i>
                </button>
                <label><Trans i18nKey="step3.paper.normal">Normal</Trans></label>
                <i className={this.item.type.includes("Normal")
                    ? "checked mc-check"
                    : "checked"}></i>
              </div>

              <div className="button-check">
                <button name="Aventura" onClick={this.functionUpdatePrice}>
                  <i style={{
                      pointerEvents: "none"
                    }} className={this.item.type.includes("Aventura")
                      ? "fas fa-umbrella active fa-2x"
                      : "fas fa-umbrella fa-2x"}></i>
                </button>
                <label><Trans i18nKey="step3.paper.resistent">Resistente</Trans></label>
                <i className={this.item.type.includes("Aventura")
                    ? "checked mc-check"
                    : "checked"}></i>
              </div>
              <div className="button-check" style={{display: this.item.type.includes("plegar") && (this.producto === 'Poster' || this.producto === 'Foto')?'flex':'none'}}>
                <button name="Rigido" onClick={this.functionUpdatePrice}>
                  <i style={{
                      pointerEvents: "none"
                    }} className={this.item.type.includes("Rigido")
                      ? "far fa-images active fa-2x"
                      : "far fa-images fa-2x"}></i>
                </button>
                <label><Trans i18nKey="step3.paper.rigid">Rígido</Trans></label>
                <i className={this.item.type.includes("Rigido")
                    ? "checked mc-check"
                    : "checked"}></i>
              </div>
              <div className="button-check" style={{display: this.item.type.includes("plegar") && this.producto === 'Foto'?'flex':'none'}}>
                <button name="Fotografico" onClick={this.functionUpdatePrice}>
                  <i style={{
                      pointerEvents: "none"
                    }} className={this.item.type.includes("Fotografico")
                      ? "far fa-images active fa-2x"
                      : "far fa-images fa-2x"}></i>
                </button>
                <label><Trans i18nKey="step3.paper.photo">Fotográfico</Trans></label>
                <i className={this.item.type.includes("Fotografico")
                    ? "checked mc-check"
                    : "checked"}></i>
              </div>
              <div className="button-check" style={{display: this.item.type.includes("plegar")&& this.producto === 'Poster'?'flex':'none'}}>
                <button name="Satinado" onClick={this.functionUpdatePrice}>
                  <i style={{
                      pointerEvents: "none"
                    }} className={this.item.type.includes("Satinado")
                      ? "fas fa-sun active fa-2x"
                      : "fas fa-sun fa-2x"}></i>
                </button>
                <label><Trans i18nKey="step3.paper.glossy">Satinado</Trans></label>
                <i className={this.item.type.includes("Satinado")
                    ? "checked mc-check"
                    : "checked"}></i>
              </div>
            </div>
            )}
            <div style={{display:this.item && this.item.id?'block':'none'}}>
              <div className='shopping-cart-table-container'>
                <table className='shopping-cart-table'>
                  <thead className='noBorder'>
                    <tr>
                      <td colSpan="2">
                        <Trans i18nKey="shoppingCart.name">name</Trans>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <Trans i18nKey="shoppingCart.units">Unidades</Trans>
                      </td>
                      <td colSpan="2" style={{ textAlign: 'center' }}>
                        <Trans i18nKey="shoppingCart.priceWithoutIVA">Precio (sin IVA)</Trans>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.renderedItems}
                  </tbody>
                </table>
              </div>
            </div>
            <div className='shopping-cart-buttons'>
              <button onClick={this.goMain}>
                <i className='far mc-arrow-left'></i>&nbsp;&nbsp;<Trans i18nKey="dialog.back">Volver</Trans>
              </button>
              <button onClick={this.addToShoppingCart.bind(this)} style={{display:this.item && this.item.id && this.showCarrito?'block':'none'}}>
                <i className='far fa-euro-sign'></i>&nbsp;&nbsp;<Trans i18nKey="step3.addCart">AÑADIR AL CARRITO</Trans>
              </button>
              <div className="errorRed duplicateerror">*<Trans i18nKey="dialog.duplicateerror">Ya presente en el carrito</Trans></div>
            </div>
          </div>
        </div>
      </LayoutSC>
    );
  }
}

export default IdPDFReuse;
